<template>
    <div>
      <!-- ::::::::::::::: Confirmação para realizar operação ::::::::::::::: -->
      <b-modal title="SGCQ Pergunta:" v-model="show">
        <b-row>
          <b-col cols="12">
            <p>{{ descricao }}</p>
          </b-col>
        </b-row>
        <template #modal-footer>
          <b-button @click="executar()" variant="info">Executar</b-button>
          <b-button @click="show = !show">Cancelar</b-button>
        </template>
      </b-modal>
    </div>
  </template>
  <script>
  export default {
    props: ["descricao"],
  
    data() {
      return {
        show: false,
      };
    },
  
    methods: {
      executar() {
        this.$emit("executar");
        this.call();
      },
  
      call() {
        this.show = !this.show;
      },
    },
  };
  </script>
  <style lang="scss" scoped></style>